const withCompany = (companyId, payload = {}) => ({
  companyId: companyId || null,
  ...payload,
});

export const queryKeys = {
  users: {
    all: (companyId) => ["users", "list", withCompany(companyId)],
    list: (companyId, params = {}) => ["users", "list", withCompany(companyId, params)],
  },
  contacts: {
    all: (companyId) => ["contacts", "list", withCompany(companyId)],
    list: (companyId, params = {}) => ["contacts", "list", withCompany(companyId, params)],
  },
  contactLists: {
    all: (companyId) => ["contactLists", "list", withCompany(companyId)],
    list: (companyId, params = {}) => ["contactLists", "list", withCompany(companyId, params)],
  },
  whatsApps: {
    all: (companyId) => ["whatsApps", "list", withCompany(companyId)],
    list: (companyId, params = {}) => ["whatsApps", "list", withCompany(companyId, params)],
  },
  queues: {
    all: (companyId) => ["queues", "list", withCompany(companyId)],
    list: (companyId) => ["queues", "list", withCompany(companyId)],
  },
  tags: {
    all: (companyId) => ["tags", "list", withCompany(companyId)],
    list: (companyId, params = {}) => ["tags", "list", withCompany(companyId, params)],
  },
  prompts: {
    all: (companyId) => ["prompts", "list", withCompany(companyId)],
    list: (companyId) => ["prompts", "list", withCompany(companyId)],
  },
  campaigns: {
    all: (companyId) => ["campaigns", "list", withCompany(companyId)],
    list: (companyId, params = {}) => ["campaigns", "list", withCompany(companyId, params)],
  },
  campaignPhrases: {
    all: (companyId) => ["campaignPhrases", "list", withCompany(companyId)],
    list: (companyId, params = {}) => ["campaignPhrases", "list", withCompany(companyId, params)],
  },
  campaignSettings: {
    all: (companyId) => ["campaignSettings", "detail", withCompany(companyId)],
    detail: (companyId) => ["campaignSettings", "detail", withCompany(companyId)],
  },
  queueIntegrations: {
    all: (companyId) => ["queueIntegrations", "list", withCompany(companyId)],
    list: (companyId, params = {}) => ["queueIntegrations", "list", withCompany(companyId, params)],
  },
  quickMessages: {
    all: (companyId) => ["quickMessages", "list", withCompany(companyId)],
    list: (companyId, params = {}) => ["quickMessages", "list", withCompany(companyId, params)],
  },
  dashboard: {
    all: (companyId) => ["dashboard", "summary", withCompany(companyId)],
    summary: (companyId, params = {}) => ["dashboard", "summary", withCompany(companyId, params)],
  },
  schedules: {
    all: (companyId) => ["schedules", "list", withCompany(companyId)],
    connections: (companyId, params = {}) => ["schedules", "connections", withCompany(companyId, params)],
    users: (companyId, params = {}) => ["schedules", "users", withCompany(companyId, params)],
    list: (companyId, params = {}) => ["schedules", "list", withCompany(companyId, params)],
    calendar: (companyId, params = {}) => ["schedules", "calendar", withCompany(companyId, params)],
  },
  flowBuilders: {
    all: (companyId) => ["flowBuilders", "list", withCompany(companyId)],
    list: (companyId, params = {}) => ["flowBuilders", "list", withCompany(companyId, params)],
    detail: (companyId, flowId) => ["flowBuilders", "detail", withCompany(companyId, { flowId })],
  },
};

export default queryKeys;
